import api from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_GOSPEL_HOME, SEO } from '../protocols';

export interface State {
    menu: Array<{
        id: number,
        name: string,
    }>,
    categorys: Array<{
        "id": number,
        "name": string,
        "image": string,
        "icon": string,
        "description": string
    }>,
    content: {
        "index-left": {
            "id": number,
            "title": string,
            "content": string
            "name": string
        },
        "index-right": {
            "id": number,
            "title": string
            "content": string
            "name": string
        }
    },
    setps: Array<{
        "id": number,
        "title": string
        "content": string
        "name": string
    }>
}

class GospelHome extends BaseModule<State> {
    constructor() {
        super(LOAD_GOSPEL_HOME[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                menu: [],
                categorys: [],
                content: {
                    'index-left': {
                        id: 0,
                        title: '',
                        content: '',
                        name: ''
                    },
                    'index-right': {
                        id: 0,
                        title: '',
                        content: '',
                        name: ''
                    }
                },
                setps: []
            },
            actions: {
                async loadData({ state, dispatch }, route: Route) {
                    let r = await api.getGospelHomeData()
                    state.categorys = r.categorys
                    state.content = r.content
                    state.setps = r.setps
                },
                async loadCategory({ state }) {
                    if (state.menu.length == 0) {
                        state.menu = await api.getGospelCategory()
                    }
                },
                [LOAD_GOSPEL_HOME[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '福音信息-一起看-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch('loadData', route),
                        dispatch('loadCategory', route)
                    ])
                }
            }
        }
    }
}

export default new GospelHome();